import { Component, OnInit, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { SliderModelService } from '../../../../services/infrastructure/sliderModel.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { MatTableDataSource } from '@angular/material/table';
import * as $ from 'jquery';

@Component({
  selector: 'app-add-reconcile-variety',
  templateUrl: './add-reconcile-variety.component.html',
  styleUrls: ['./add-reconcile-variety.component.scss']
})
export class AddReconcileVarietyComponent implements OnInit {
  private subscription = new Array<Subscription>();
  displayedColumns: string[] = ['marketingBrand', 'variety', 'availableQty', 'orderQty', 'uom', 'preferredPackagingSize'];
  isPlaceOrderDisable = true;
  associateItemList: any;
  productSearchFilter: string = "Variety";
  productFilters: any;
  marketingMasterList: any = [];
  filterValueList: any = [];
  associateOrderSource: MatTableDataSource<any>;
  errorsList: Array<string> = [];
  error = false;
  associateOrderSourceCopy: any;
  errorMsgs = new Array();
  index = 0;

  // Search Type set Up for grid
  searchTypeList: any[] = [
    { name: 'Variety', value: 'Variety' },
    { name: 'Marketing Brand', value: 'marketingBrand' }
  ];

  constructor(private sliderModelService: SliderModelService,
    private loaderService: LoaderService) {
  }

  ngOnInit() {
    this.bindDataSource([], true);
    this.resetProductFilter();
    this.getOrderDetails();
  }

  
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.sliderModelService.initializeReconcileVarietyDataSliderValue.subscribe(data => {
      let rowId: Number = 0;
      this.associateItemList = data;
      let marketingIds = [];
      const seen = new Set();
      this.associateItemList.forEach(product => {
        if (!seen.has(product.marketingBrand)) {
          seen.add(product.marketingBrand);
          marketingIds.push({ id: product.marketingBrand, value: product.marketingBrand ? product.marketingBrand : 'Blank' });
        }
        rowId = +rowId + 1;
        product.rowId = +rowId;
        product.orderQty = 0;
        product.preferredPackagingSize = '';
        product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
      });
      marketingIds = marketingIds.sort((a, b) => a.value.localeCompare(b.value));
      this.marketingMasterList = marketingIds;
      this.bindDataSource(this.associateItemList, true);
      this.loaderService.setLoaderStatus(false);


    }));
  }


  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setSeedEditPageHeight();
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }


  enableDisablePlaceOrder() {
    if (this.associateOrderSource && this.associateOrderSource.data && this.associateOrderSource.data.length > 0 && this.associateOrderSource.data.some(x => x.orderQty > 0)
      && !this.associateOrderSource.data.some(x => x.lineErrors?.errors.length > 0)) {
      this.isPlaceOrderDisable = false;
    }
    else {
      this.isPlaceOrderDisable = true;
    }
  }


  getFilterData() {
    this.keepFilter();
    this.applyFilterData(this.productFilters);
  }

  // Keep the selected filter in case of edit
  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.Variety && this.productFilters.Variety != '') {
          this.filterValueList.push('Variety : ' + this.productFilters.Variety);
        }
        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          let strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + (x ? x : 'Blank') + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
      }
    }

  }

  // Clear the selected filters
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
  }

  // Clear single filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
      if (this.filterValueList.length < 1) {
        // remove all filter
      }
    }
  }



  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        break;
      case 'Product Name':
        this.productFilters.Variety = '';
        break;
      default:
        break;
    }
  }

  // Reset the filters
  resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'Variety': null,
      'MarketingBrandList': []
    };
  }

  // Search based on filter type
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toLocaleLowerCase().indexOf(term) > -1;
  }


  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.associateOrderSource.filter = filterValue;
  }

  quantityTextChange(productItem) {
    if (/^0/.test(productItem.orderQty) && productItem.orderQty != '0') {
      productItem.orderQty = productItem.orderQty.replace(/^0/, '');
    }
  }

  // Associate Order Unit Change and validation
  AssociateOrderUnitChange(action: string, productItem: any) {
    if (action === 'decrease') {
      productItem.orderQty = Math.max(0, +productItem.orderQty - 1);
    }
    else if (action === 'increase') {
      productItem.orderQty = +productItem.orderQty + 1;
    }
    //productItem.orderQty = Math.min(productItem.orderQty, productItem.availableQty);
    this.validateLineItem(productItem, 'orderQty');
  }


  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.associateOrderSource = new MatTableDataSource(orderList);

      this.associateOrderSource.filterPredicate = (data: any, filter: any) => {
        if (data.variety == null || data.variety == 'undefined') {
          data.variety = '';
        }
        if ((filter.Variety == null || data.variety.toLowerCase().indexOf(filter.Variety.toLowerCase()) > -1) &&
          (filter.MarketingBrandList.length == 0 || filter.MarketingBrandList.indexOf(data.marketingBrand) > -1)) {
          return true;
        }
        else {
          return false;
        }
      };

      this.applyFilterData(this.productFilters);
      // created deep copy
      if (isClone) {
        this.associateOrderSourceCopy = JSON.parse(JSON.stringify(orderList));
      }
      this.enableDisablePlaceOrder();
    }
  }


  // Line item validation
  validateLineItem(item: any, validateField) {
    //this.enableDisablePlaceOrder();

    if (validateField != '') {
      if (validateField == 'orderQty') {
        if (item.availableQty < +item.orderQty) {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
          item.lineErrors.errors.push({
            id: 'availableUnits', error: 'Order Qty should not be greater than Available Qty'
          });
        }
        else {
          item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }
      }
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }

    this.enableDisablePlaceOrder();
    this.associateOrderSource.data = [...this.associateOrderSource.data];
   // this.table.renderRows();
    return item;


  }


  addHybridVariety() {
    this.sliderModelService.reconcileVarietySelected.next(this.associateOrderSource?.data.filter(x => x.orderQty > 0));
    this.sliderModelService.reconcileVarietySlider.next(false);
    this.sliderModelService.close();
  }

  cancelClick() {
    this.sliderModelService.reconcileVarietySlider.next(false);
    this.sliderModelService.close();
  }

  isExpansionRow = (_: number, row: any) =>
  row?.lineErrors?.errors?.length > 0;

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
